"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTabs = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var LinkedProject_1 = require("../LinkedProject");
var ProjectTabs = function (props) {
    var _a = React.useState(0), activeProject = _a[0], setActiveProject = _a[1];
    var mapTabName = function (project) { return (React.createElement("div", { key: "tab-".concat(project.vektorioId) }, project.name)); };
    var tabs = props.vektorioProjects.map(mapTabName);
    var mapTabContent = function (project) { return (React.createElement(LinkedProject_1.LinkedProject, { key: "tab-content-".concat(project.vektorioId), currentProject: props.currentProject, vektorioProject: project })); };
    var tabContents = props.vektorioProjects.map(mapTabContent);
    var content = tabs.concat(tabContents);
    return (React.createElement(sok_ui_1.Tabs, { activeIndex: activeProject, onClick: setActiveProject }, content));
};
exports.ProjectTabs = ProjectTabs;
